import {
  IKnmPunishmentNature,
  IKnmPunishmentNatureOption,
} from '../../../APIPackage/KnmModule/interfaces/IKnmPunishmentNature';

export const createPunishmentNatureSelectOption = (value: IKnmPunishmentNature): IKnmPunishmentNatureOption => ({
  id: value.id,
  label: value.name,
  value,
});
